// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"567":"798f3de6","3019":"798f3de6","4558":"778e0c1f","5105":"b60e442b","6805":"798f3de6","8415":"798f3de6","9187":"b60e442b"}[chunkId] + ".chunk.css";
};